import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../Shared/LoadingSpinner";

const ViewStudent = () => {
  const { id } = useParams();
  const { data: student, isLoading } = useQuery(["student"], () =>
    fetch(`https://evaluation-server.onrender.com/getSingleStudent/${id}`).then(
      (res) => res.json()
    )
  );

  if (isLoading) {
    return <LoadingSpinner></LoadingSpinner>;
  }

  return (
    <div>
      <div>
        <p className="font-bold mb-4">View student</p>
      </div>
      <div className="border-4 border-indigo-500 my-5 rounded-md w-40">
        <img src={student.image} alt="" />
      </div>
      <form className="flex flex-col">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 pb-16">
          <div>
            <input
              defaultValue={student.firstName}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
            />
          </div>

          <input
            defaultValue={student.middleName}
            className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
          />

          <div>
            <input
              defaultValue={student.lastName}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
            />
          </div>

          <input
            defaultValue={student.classValue}
            className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
          />
          <input
            defaultValue={student.division}
            className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
          />

          <div>
            <input
              defaultValue={student.roll}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pb-5">
          <div>
            <input
              defaultValue={student.address1}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
            />
          </div>

          <input
            defaultValue={student.address2}
            className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          <div>
            <input
              defaultValue={student.landmark}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
            />
          </div>

          <div>
            <input
              defaultValue={student.city}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
            />
          </div>

          <div>
            <input
              defaultValue={student.pin}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ViewStudent;
